<template>
  <v-expansion-panel v-bind="resetProps">
    <v-expansion-panel-header hide-actions>
      <template v-slot:default="props">
        <slot name="header" v-bind="{ ...props }" />
      </template>
    </v-expansion-panel-header>
    <v-expansion-panel-content>
      <slot />
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
export default {
  name: "WindowPanel",

  computed: {
    resetProps() {
      return { ...this.$attrs };
    },
  },
};
</script>
